import { Entry } from '../Entry'

export function Entry20260603() {
  return (
    <Entry title="2026 Jun 3 - v3.11.12">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/25475/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
